import { useState } from 'react';
import CartOpenButton from '../components/FloatingCartButton';
import SideCart from '../components/SideCart';

const App = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  return (
    <>
      <CartOpenButton onOpenCart={() => setIsCartOpen(true)} />

      <SideCart
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
      />
    </>
  );
};

export default App;
